module.exports = __webpack_public_path__ + "img/home6.eb958fb5.svg";